import { AppBar, Button, Dialog, Grid, List, ListItem, ListItemText, Toolbar, Typography } from "@mui/material"
import { useListaDeduplicacaoService } from "../../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { Transition } from "../../../../../../../components"
import { FileUpload } from "./FileUpload"
import { useState } from "react"
import '../../../../../../../assets/css/fileUploadStyle.css'
import { ColumnsDialog } from "./ColumnsDialog"
import { ListItemButtonStyled } from "../../localizacao/lista-cep/forms/ListItemButtonStyled"
import { PreviewListaDeduplicacao } from "./PreviewListaDeduplicacao"

export const ListaDeduplicacaoImportFile = (props: {
    openImportFile: boolean
}) => {
    // State
    const { listaDeduplicacao } = useAppSelector((state) => state)
    // Use State
    const [columnDialogOpen, setColumnDialogOpen] = useState<boolean>(false)
    // Hook
    const {
        openImportFileListaDeduplicacao,
        verifyListaDeduplicacaoFileData,
        openPreviewListaDeduplicacao,
        selectColumn
    } = useListaDeduplicacaoService()

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="xl"
                open={listaDeduplicacao.openImportFileListaDeduplicacao}
                TransitionComponent={Transition}
                onClose={() => {
                    openImportFileListaDeduplicacao(false)
                }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} textTransform="uppercase" variant="h6" component="div">
                            Importar arquivo com CPFs
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => {
                                openImportFileListaDeduplicacao(false)
                            }}
                        >
                            Fechar
                        </Button>
                    </Toolbar>
                </AppBar>
                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        openImportFileListaDeduplicacao(false)
                    }}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {/* Drag and drop component*/}
                            <FileUpload label={"Arraste e solte o arquivo aqui ou clique para selecionar"} />
                        </Grid>
                        {
                            listaDeduplicacao.matchCode.selectedColumn !== '' && (
                                <>
                                    <Grid item xs={6}>
                                        <List component="div" role="group">
                                            <ListItem
                                                key={1}
                                                divider
                                                aria-haspopup="true"
                                                aria-controls="ringtone-menu"
                                                aria-label="phone ringtone"
                                                onClick={(() => {
                                                    setColumnDialogOpen(true)
                                                })}
                                            >
                                                <ListItemText key={1}
                                                    primary="Clique para selecionar a coluna"
                                                    secondary={listaDeduplicacao.matchCode.selectedColumn}
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <List component="div" role="group">
                                            <ListItemButtonStyled
                                                divider
                                                key={1}
                                            >
                                                <ListItemText primary="Dados do arquivo"
                                                    secondary={
                                                        <>
                                                            <Typography >
                                                                <strong> Nome: </strong>
                                                                {listaDeduplicacao.fileData.name}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Tamanho: </strong>
                                                                {listaDeduplicacao.fileData.size}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Tipo: </strong>
                                                                {listaDeduplicacao.fileData.type}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Linhas: </strong>
                                                                {listaDeduplicacao.fileData.data.length.toLocaleString('pt-BR')}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Match codes distintos: </strong>
                                                                {listaDeduplicacao.matchCode.distinctValues.toLocaleString('pt-BR')}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Match codes válidos e distintos: </strong>
                                                                {listaDeduplicacao.matchCode.validValues.toLocaleString('pt-BR')}
                                                            </Typography>
                                                        </>
                                                    }
                                                />
                                            </ListItemButtonStyled>
                                        </List>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (verifyListaDeduplicacaoFileData()) {
                                                    openPreviewListaDeduplicacao(true)
                                                }
                                            }}
                                        >
                                            Enviar
                                        </Button>
                                    </Grid>
                                </>
                            )
                        }
                    </Grid>
                    <ColumnsDialog
                        id="ringtone-menu"
                        keepMounted
                        open={columnDialogOpen}
                        onClose={(newValue?: string) => {
                            if (newValue) {
                                selectColumn({
                                    selectedColumn: newValue
                                })
                            }
                            setColumnDialogOpen(false)
                        }}
                        value={listaDeduplicacao.matchCode.selectedColumn}
                    />
                </form>
            </Dialog>

            <PreviewListaDeduplicacao openPreviewListaDeduplicacao={listaDeduplicacao.openPreviewListaDeduplicacao} />
        </>
    )
}